var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bonusesCount
    ? _c("div", { staticClass: "product-bonus" }, [
        _c(
          "div",
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.IconCard.id }
            })
          ],
          1
        ),
        _vm._v(
          "\n  " + _vm._s(_vm.bonusesCount) + " бонусов на клубную карту\n"
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }